import {combineReducers, Reducer} from "redux";
import {WidgetsState} from "@models/widget";
import {WidgetsActionTypes} from "@actions/widget";

// Type-safe initialState!
export const initialState: WidgetsState = {
    allIds: [],
    byId: {},
    loading: false,
    count: 0
};

const byId = (state = initialState.byId, action) => {
    switch (action.type) {
        case WidgetsActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return {
                ...data.reduce((obj, widget) => {
                    obj[widget.id] = {
                        ...widget,
                        is_fetched: false,
                        ...(state[widget.id] || {}) //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case WidgetsActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});

        case WidgetsActionTypes.CREATE_SUCCESS: {
            const widget = action.payload;
            return {
                ...state,
                [widget.id]: widget
            };
        }

        case WidgetsActionTypes.UPDATE_SUCCESS: {
            const widget = action.payload;
            return {
                ...state,
                [widget.id]: {
                    ...state[widget.id],
                    ...widget
                }
            };
        }

        case WidgetsActionTypes.FETCH_ITEM_SUCCESS: {
            const widget = action.payload;
            return {
                ...state,
                [widget.id]: {
                    ...state[widget.id],
                    ...widget,
                    is_fetched: true
                }
            };
        }

        default:
            return state;
    }
};

const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case WidgetsActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map(item => item.id);
        }

        case WidgetsActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [
                ...state.slice(0, deletedFormIndex),
                ...state.slice(deletedFormIndex + 1)
            ];

        case WidgetsActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        case WidgetsActionTypes.UPDATE_ORDER_SUCCESS:
        case WidgetsActionTypes.UPDATE_ORDER_ERROR:
            return action.payload.map(item => item.id);

        default:
            return state;
    }
};

const count = (state = initialState.count, action) => {
    switch (action.type) {
        case WidgetsActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case WidgetsActionTypes.DELETE_SUCCESS:
            return state - 1;

        case WidgetsActionTypes.CREATE_SUCCESS:
            return state + 1;
        default:
            return state;
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case WidgetsActionTypes.FETCH_REQUEST: {
            return true;
        }

        case WidgetsActionTypes.FETCH_SUCCESS:
        case WidgetsActionTypes.FETCH_ERROR:
            return false;

        default:
            return state;
    }
};

const reducer: Reducer<WidgetsState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export {reducer as widgetReducer};

//Selectors
export const getWidgetsList = widgets =>
    widgets.allIds.map(id => widgets.byId[id]);
export const getWidgetById = (widgets, id) => widgets.byId[id];
